<template>
<div>
    <header class="slider" v-if="!isDzhApp && sliderLists.length>0">
        <div class="slider-wrap">
          <ul class="slider-list">
            <li v-for="(item,index) in sliderLists">
              <p>{{item.title}}</p>
              <a href="javascript:void(0)"  class="slider-btn" @click="openApp(item.id,item.url)">打开</a>
            </li>
          </ul>
        </div>
        <div class="dot"></div>
    </header>
	<article class="news-detail">
		<h1 class="news-tit">{{title}}</h1>
		<h2 class="news-source">来源：
			<span class="source-site">{{source}}</span>
			<span class="source-date">{{otime}}</span>
		</h2>
		<section class="news-text">
			<div v-html="content"></div>
      <br>
      <div v-show="sharePolicy">免责声明：本文所示内容出于传递更多信息，不构成投资建议。本公司力求但不保证数据的完全准确，投资者据此操作风险自担。</div>
		</section>
	</article>
  
  <footer class="foot-bar" v-if="!isDzhApp" @click="openApp(0,'')">
      <div class="foot-bar-wrap">
          <div class="comment-box" contenteditable="true" placeholder="发表你的看法"></div>
          <div class="operate-btns">
              <a class="btn-share" href="javascript:void(0);"></a>
              <a class="btn-comment" href="javascript:void(0);"></a>
          </div>
      </div>    
      <a class="btn-red" href="javascript:void(0);">买基金</a>
      <a class="btn-blue" href="javascript:void(0);">买股票</a>    
  </footer>

</div>
</template>

<script>
import axios from 'axios'
import wxshare from '@/assets/js/wxshare'

export default {
	name: 'gwshare',
	data () {
	    return {
	      title: '--',
	      source: '--',
	      otime:'----- --:--:--',
	      content:'分享内容',
	      jsonurl:'',
	      isDzhApp:0,
        sliderLists:[],
        sharePolicy:1
	    }
  	},
  	created() {
  		let self = this;

  		this.jsonurl = self.$route.query.jsonurl;

      if (this.jsonurl.substr(0,5) != "https") {
        this.jsonurl = "https"+this.jsonurl.substr(4);
      }

  		axios.get(this.jsonurl+"?r="+Math.random()).then(response => {
	        let res = response.data[0];
	        self.title = res.title;
	        self.source = res.source;
	        self.otime = res.otime;

          if(res.hasOwnProperty('sharePolicy')){  //是否显示免职声明
            self.sharePolicy = res.sharePolicy;
          }else{
            self.sharePolicy = 1;
          }

          // if(self.title.indexOf("江泽民") > 0){
          //   self.sharePolicy=1;
          // }
          
	        if(!wxshare.is_dzhapp()){
	        	self.content = res.content.replace(new RegExp("<a[^>]*href=\"@[^\"]*",'gm'),"<a href=javascript:void();");
	        }else{
	        	self.content = res.content;

	        }

	    }).then(()=>{
	    	wxshare.do(self.jsonurl,'http://static.yundzh.com/logo.png',self.title,'大智慧分享');
	    });

      // var topUrl = "http://newmnews.gw.com.cn/wap/data/news/txs/topkxnews.json";  //测试
      var topUrl = "https://mnews.gw.com.cn/wap/data/news/txs/topkxnews.json?r="+Math.random();  //外网

      axios.get(topUrl).then(response => {
         self.sliderLists = response.data.data;
      }).then(()=>{
        self.swipe()
      })

	    if(wxshare.is_dzhapp()){
	    	this.isDzhApp = 1;
	    } else {
	    	this.isDzhApp = 0;
	    }
  	},
  	methods: {
        openApp:function(id, url){
          if(url == ''){
          	 var info = "dzh_browser_url&goto=0&screen=230";
          }else{
          	 var info = "dzh_browser_url&goto=0&screen=310&url="+encodeURIComponent(url);
          }
          //var downloadUrl = "https://share.gw.com.cn/openapp/download.html";  //测试
          var downloadUrl = "https://dzhopenapp.gw.com.cn/openapp/download.html";      //外网

          var hrefUrl = downloadUrl + "?info=" + (encodeURIComponent(info));


          console.log(hrefUrl);
          window.location.href = hrefUrl;
        },
        swipe:function(){
          if($(".slider-list > li").length>1){
            for(var i=0;i<$(".slider-list > li").length;i++){
              $(".dot").append("<span></span>");
            }
          }
          $(".dot > span").eq(0).addClass("cur");
          window.mySwipe = new Swipe($(".slider-wrap")[0], {
            auto:3000,
            speed: 600,
            continuous: true,
            disableScroll: true,  //阻止由于触摸而滚动屏幕
            stopPropagation: false,  //停止滑动事件
            callback: function(index, elem) {
              if($(".dot > span").length<=2){
                  index = index%2;
              }
              $(".dot > span").eq(index).addClass("cur").siblings().removeClass("cur");
            }
          });
        }
  	},
  	mounted() {
  		//this.$nextTick(function () {
	    //  wxshare.do(this.jsonurl,'http://static.yundzh.com/logo.png',this.title,'大智慧分享');
	    //})
       // 头部轮播
	 }
}
</script>



// WEBPACK FOOTER //
// src/components/mnewsshare.vue